import { render, staticRenderFns } from "./TalkRoomList.vue?vue&type=template&id=4b0473c6&scoped=true"
import script from "./TalkRoomList.vue?vue&type=script&lang=js"
export * from "./TalkRoomList.vue?vue&type=script&lang=js"
import style0 from "./TalkRoomList.vue?vue&type=style&index=0&id=4b0473c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0473c6",
  null
  
)

export default component.exports